import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3000/',
  timeout: 5000,
});

// 요청 인터셉터
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

// 응답 인터셉터
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      // 토큰 삭제
      localStorage.removeItem('token');
      // 로그인 페이지로 리다이렉트
      window.location.href = '/';
    }
    return Promise.reject(error);
  },
);

/**
 * @description API 요청을 보내는 함수
 * @param {string} method - 요청 메서드
 * @param {string} path - API 경로
 * @param {Object} data - 요청 데이터
 * @returns {Promise} - API 응답
 */
export const request = async (method, path, data) => {
  try {
    const res = await api[method](path, data);
    return res;
  } catch (error) {
    console.info('request error', error);
    return error;
  }
};

export default api;
